import { render, staticRenderFns } from "./OrderCart.vue?vue&type=template&id=55624efe"
import script from "./OrderCart.vue?vue&type=script&lang=js"
export * from "./OrderCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports